import { z } from 'zod';

// Settings that follow you to every device you sign in on: how the app looks, and your bookshelf.

export const appearancePreference = z.object({
  style: z.enum(['classic', 'sleek', 'playful']),
  mode: z.enum(['system', 'light', 'dark']),
});
export type AppearancePreference = z.infer<typeof appearancePreference>;

/** What a shelf board is made of. */
export const SHELF_FINISHES = ['oak', 'walnut', 'birch', 'white', 'graphite', 'rose'] as const;
export type ShelfFinish = (typeof SHELF_FINISHES)[number];

export const shelfPreference = z.object({
  /** Null: the current style's own finish. */
  finish: z.enum(SHELF_FINISHES).nullable(),
  /** Books standing face out, or spine out. */
  layout: z.enum(['covers', 'spines']),
});
export type ShelfPreference = z.infer<typeof shelfPreference>;
export const DEFAULT_SHELF: ShelfPreference = { finish: null, layout: 'covers' };

export const preferencesResponse = z.object({
  /** Null until one is chosen (the device's own choice then becomes the account's). */
  appearance: appearancePreference.nullable(),
  shelf: shelfPreference,
});
export type Preferences = z.infer<typeof preferencesResponse>;

/** Change either, or both; what's left out stays as it is. */
export const updatePreferencesInput = z
  .object({ appearance: appearancePreference.optional(), shelf: shelfPreference.partial().optional() })
  .refine((v) => v.appearance !== undefined || Object.keys(v.shelf ?? {}).length > 0);
